import { z } from "zod";

export const EditCustomerSchema = z.object({
  first_name: z
    .string({ message: "First name is required" })
    .min(2, "Please Enter your First Name")
    .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabets and spaces."),
  middle_name: z.string().optional(),
  last_name: z.string().optional(),
  phone_no: z
    .string()
    .trim()
    .min(10, "Phone number must be 10 digits")
    .max(10, "Phone number must be 10 digits")
    .regex(/^[6-9]\d{9}$/, "Invalid phone number"),
  whatsapp_number: z
    .string()
    .trim()
    .min(10, "Whatsapp number must be 10 digits")
    .max(10, "Whatsapp number must be 10 digits")
    .regex(/^[6-9]\d{9}$/, "Invalid phone number"),
  state: z
    .string({ message: "State is required" })
    .min(2, "Enter Your State"),
  district: z
    .string({ message: "District is required" })
    .min(2, "Enter your Disctrict"),
  city: z
    .string({ message: "City is required" })
    .min(2, "Enter Your City/Town"),
  pin: z
    .string({ message: "Pin is required" })
    .min(6, "Enter a valid Pin Code"),
  gender: z.string({ message: "Gender is required" }).min(2, "Gender is required"),
  address: z
    .string({ message: "Address is required" })
    .min(6, "Enter Your Address"),
});

export type EditCustomerFormValues = z.infer<typeof EditCustomerSchema>;
